var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { doesPropExistAndHasItChanged } from "@nexio/emvio-util-app";
import CaretDown from "../../icons/caretDown";
import ToolTip from "../../shared/toolTip/ToolTip";
import "./selectComponent.scss";
import { getValidationError } from "../../utils/formUtils";
import { createId } from "../../utils/uniqueId";
import { checkRequired } from "../input/inputValidators";
export class SelectComponent extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "isValueInListOfOptions", (value) => {
      const { options = [] } = this.props;
      return options.some((option) => option.value === value);
    });
    __publicField(this, "updateValue", (value) => {
      if (this.isValueInListOfOptions(value)) {
        this.setState({ value }, () => this.validate(true));
      }
    });
    __publicField(this, "validate", (isInitialValidation) => {
      const error = getValidationError(this.state.value, this.props.validations);
      this.setState((prevState) => {
        return {
          isValid: !error,
          errorMsg: error,
          isTouched: !isInitialValidation || prevState.isTouched
        };
      });
      return !error;
    });
    __publicField(this, "changeHandler", (e) => {
      _.invoke(e, "persist");
      const newValue = e.target.value;
      this.setState({
        value: newValue,
        isTouched: true,
        isChanged: !_.isEqual(this.state.initialValue, newValue)
      }, () => {
        this.validate(), this.props.onChange && this.props.onChange(newValue);
      });
    });
    __publicField(this, "focusHandler", () => {
      this.setState({
        isFocused: true,
        isTouched: true
      });
    });
    __publicField(this, "blurHandler", () => {
      this.setState({
        isFocused: false
      });
    });
    __publicField(this, "getComponentCssClasses", () => {
      return [
        "selectComponent",
        this.state.isValid ? "valid" : "invalid",
        this.state.isTouched ? "touched" : "untouched",
        this.state.isFocused ? "focused" : "unfocused",
        this.state.value ? "populated" : "unpopulated",
        this.state.isChanged ? "changed" : "unchanged",
        this.props.disabled ? "disabled" : "enabled",
        this.props.className ? this.props.className : ""
      ];
    });
    __publicField(this, "renderMessage", () => {
      const errorMsg = this.state.errorMsg;
      const hint = this.props.hint;
      const messageText = this.state.isTouched && errorMsg ? errorMsg : hint;
      return /* @__PURE__ */ jsx("div", { className: "message", children: messageText });
    });
    __publicField(this, "render", () => {
      const options = [
        /* @__PURE__ */ jsx("option", { value: "", disabled: this.state.isRequired }, "blank"),
        ...this.props.options.map((option) => {
          const key = _.isObject(option.value) ? JSON.stringify(option.value) : option.value;
          return /* @__PURE__ */ jsx(
            "option",
            {
              value: option.value,
              disabled: option.isDisabled,
              title: option.title,
              children: option.name
            },
            key
          );
        })
      ];
      const selectClasses = this.getComponentCssClasses();
      const { label } = this.props;
      const inputLabel = this.state.isRequired ? /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx("span", { className: "required-asterisk", children: "*" }),
        label
      ] }) : label;
      return /* @__PURE__ */ jsxs("div", { className: selectClasses.join(" "), children: [
        /* @__PURE__ */ jsx("div", { className: "selectCaret", children: /* @__PURE__ */ jsx(CaretDown, { className: "caret" }) }),
        /* @__PURE__ */ jsxs("label", { htmlFor: this.state.id, children: [
          inputLabel,
          /* @__PURE__ */ jsx("span", { children: this.props.toolTip ? /* @__PURE__ */ jsx(ToolTip, { message: this.props.toolTip }) : null })
        ] }),
        /* @__PURE__ */ jsx(
          "select",
          {
            id: this.state.id,
            name: this.props.name,
            value: this.state.value,
            onChange: this.changeHandler,
            onFocus: this.focusHandler,
            onBlur: this.blurHandler,
            disabled: this.props.disabled,
            title: this.props.title,
            children: options
          }
        ),
        this.renderMessage()
      ] });
    });
    const isRequired = _.includes(props.validations, checkRequired);
    let initialValue = "";
    if (this.isValueInListOfOptions(this.props.value)) {
      initialValue = props.value;
    } else if (isRequired && props.options.length === 1) {
      initialValue = props.options[0].value;
      this.props.onChange(initialValue);
    }
    this.state = {
      id: this.props.id || createId("selectComponent"),
      initialValue,
      value: initialValue,
      isPopulated: !!props.value,
      isFocused: false,
      isTouched: false,
      isChanged: false,
      isValid: true,
      isRequired
    };
  }
  componentDidUpdate(prevProps) {
    if (doesPropExistAndHasItChanged(prevProps, this.props, "value")) {
      if (this.isValueInListOfOptions(this.props.value)) {
        this.updateValue(this.props.value);
      }
    }
    const isRequired = _.includes(this.props.validations, checkRequired);
    if (isRequired && !this.state.isRequired) {
      this.setState({ isRequired });
    } else if (!isRequired && this.state.isRequired) {
      this.setState({ isRequired });
    }
    if (doesPropExistAndHasItChanged(prevProps, this.props, "options")) {
      const { options } = this.props;
      if (isRequired && _.size(options) === 1) {
        const value = options[0].value;
        this.updateValue(value);
        this.props.onChange(value);
      }
    }
    if (_.isEmpty(prevProps.options) && !_.isEmpty(this.props.options)) {
      const { value } = this.props;
      this.updateValue(value);
    }
  }
}
SelectComponent.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  toolTip: PropTypes.array,
  value: PropTypes.any,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      name: PropTypes.string
    })
  ),
  className: PropTypes.string,
  onChange: PropTypes.func,
  hint: PropTypes.string,
  validations: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.func),
    PropTypes.func
  ]),
  disabled: PropTypes.bool,
  title: PropTypes.string
};
export default SelectComponent;
